const getDefaultPath = (cashierPath: string, type: string, name: string) => {
  const isPathDeposit = cashierPath === 'deposit';
  if (isPathDeposit && type === 'coin' && name !== '') {
    return `${cashierPath}-${name}`;
  }
  return 'home';
};

export default getDefaultPath;
